import { render, staticRenderFns } from "./homeInfo.vue?vue&type=template&id=477c14eb&scoped=true"
import script from "./homeInfo.vue?vue&type=script&lang=js"
export * from "./homeInfo.vue?vue&type=script&lang=js"
import style0 from "./homeInfo.vue?vue&type=style&index=0&id=477c14eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c14eb",
  null
  
)

export default component.exports